import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { TARIFFICATOR_BILLING_PRODUCT_ID } from '@/shared/lib/analytics/offer';
import { getOfferTitle } from '@/shared/lib/analytics';

interface SubscriptionOfferAnalyticsParams {
    buttonText: string;
    offer: Offer | null;
    entityType?: string;
}

interface SubscriptionOfferAnalytics {
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
    setOffer(offer: Offer): void;
}

const extractOfferAnalyticsData = (offer: Offer | null) => ({
    tariffName: offer?.catalogCompositeOffer?.tariffOffer?.name ?? '',
    optionName: offer?.catalogCompositeOffer.optionOffers[0]?.name ?? '',
    batchId: offer?.analyticData.batchId ?? '',
    positionId: offer?.analyticData.positionId ?? '',
});

export function createSubscriptionOfferAnalytics(
    eventSender: AnalyticsSender,
    { buttonText, entityType, offer }: SubscriptionOfferAnalyticsParams
): SubscriptionOfferAnalytics {
    let storedOffer: Offer | null = offer;

    return {
        setOffer(offer: Offer | null) {
            storedOffer = offer;
        },
        showed() {
            const { tariffName, optionName } = extractOfferAnalyticsData(storedOffer);

            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                buttonText,
                offerTitle: getOfferTitle(storedOffer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                show: storedOffer?.offerPositionsData ?? {},
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
            });
        },
        navigated() {
            const { tariffName, optionName } = extractOfferAnalyticsData(storedOffer);

            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                buttonText,
                offerTitle: getOfferTitle(storedOffer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                click: storedOffer?.offerPositionsData ?? {},
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: storedOffer?.billingProductIds ?? '',
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            const { tariffName, optionName } = extractOfferAnalyticsData(storedOffer);

            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                buttonText,
                offerTitle: getOfferTitle(storedOffer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: storedOffer?.billingProductIds ?? '',
            });
        },
    };
}
